import { EXCLUDED_DROPOFF_LOCATIONS } from 'src/utils/Constants';

export const DELIVERED_LOCATION_LABEL_KEY = 'swiship_dropoff_location_label';

/*
 * Allowed translator-key prefixes for the 3P "Delivered location" row:
 *  - delivered_location_*                : Panther carrier-specific fallback keys
 *  - shiptrack_loc_* / shiptrack-loc-*   : STS location keys (underscore and hyphen forms)
 * STS `DeliveryLocationCodeToTranslatorKey` config map:
 * https://code.amazon.com/packages/ShipmentTrackingService/blobs/mainline/--/configuration/brazil-config/app/ShipmentTrackingService.cfg
 */
export const ALLOWED_DELIVERED_LOCATION_PREFIXES = [
  'delivered_location_',
  'shiptrack_loc_',
  'shiptrack-loc-',
];

// mc_* keys describe the recipient (mc_boy / mc_girl / mc_man / mc_woman / ...), not a location, so
// they are denied for privacy.
export const DENIED_DELIVERED_LOCATION_PREFIX = 'shiptrack_loc_mc_';

const isSupportedDeliveredLocationKey = (key: string): boolean =>
  !key.startsWith(DENIED_DELIVERED_LOCATION_PREFIX) &&
  ALLOWED_DELIVERED_LOCATION_PREFIXES.some((prefix) => key.startsWith(prefix));

// Show the "Delivered location" row only when DELIVERED, the key is allowed, and there is no
// displayable AMZL drop-off (the two are mutually exclusive; drop-off wins).
export const shouldShowDeliveredLocation = (
  transitState?: string,
  additionalLocationTranslatorKey?: string,
  packageDropOffLocation?: string
): boolean => {
  const hasDisplayableDropOff =
    !!packageDropOffLocation && !EXCLUDED_DROPOFF_LOCATIONS.includes(packageDropOffLocation);
  return (
    transitState === 'DELIVERED' &&
    !hasDisplayableDropOff &&
    !!additionalLocationTranslatorKey &&
    isSupportedDeliveredLocationKey(additionalLocationTranslatorKey)
  );
};
